class AccordionDrag {
  constructor(containerId, prevBtn, nextBtn) {
    this.track = document.getElementById(containerId)
    this.container = this.track.parentElement
    this.panes = Array.from(this.track.children)
    this.activeIndex = 0
    this.totalVisible = 4
    this.isDragging = false
    this.startX = 0
    this.currentTranslate = 0
    this.prevTranslate = 0
    this.prevBtn = prevBtn
    this.nextBtn = nextBtn

    this.init()
  }

  init() {
    this.setActive(0)
    this.bindEvents()
  }

  updateButtons() {
    if (this.activeIndex === 0) {
      this.prevBtn.style.opacity = 0.1
    } else {
      this.prevBtn.style.opacity = 1
    }
    if (this.activeIndex + 1 == this.panes.length) {
      this.nextBtn.style.opacity = 0.1
    } else {
      this.nextBtn.style.opacity = 1
    }
  }

  setActive(index) {
    this.activeIndex = index
    this.panes.forEach((pane, i) => {
      const isActive = i === index
      pane.classList.toggle('active', isActive)
    })
    this.scrollToActive()
    this.updateButtons()
  }

  scrollToActive() {
    const containerWidth = this.container.offsetWidth
    const activePane = this.panes[this.activeIndex]

    const beforePanes = this.panes.slice(0, this.activeIndex)
    let offsetLeft = 0

    beforePanes.forEach((p) => {
      offsetLeft += p.offsetWidth
    })

    let shift
    if (this.activeIndex === 0) {
      shift = 0
    } else {
      const showLeftPane = this.panes[this.activeIndex - 1].offsetWidth
      if (containerWidth > 768) {
        shift = offsetLeft - showLeftPane
      } else {
        shift = this.panes[this.activeIndex].offsetLeft
      }
    }

    const maxScroll = this.track.scrollWidth - containerWidth
    shift = Math.max(0, Math.min(shift, maxScroll))

    this.currentTranslate = -shift
    this.prevTranslate = this.currentTranslate
    this.track.style.transition = 'transform 0.3s ease'
    this.track.style.transform = `translateX(${this.currentTranslate}px)`
  }

  bindEvents() {
    const wrapper = this.container

    const pointerDown = (e) => {
      this.isDragging = true
      this.startX = e.clientX
      this.track.style.transition = 'none'
    }

    const pointerMove = (e) => {
      if (!this.isDragging) return
      const dx = e.clientX - this.startX
      this.currentTranslate = this.prevTranslate + dx
      this.track.style.transform = `translateX(${this.currentTranslate}px)`
    }

    const pointerUp = () => {
      if (!this.isDragging) return
      this.isDragging = false
      this.track.style.transition = 'transform 0.3s ease'

      const containerRect = this.container.getBoundingClientRect()
      const centerX = containerRect.left + containerRect.width / 2

      const paneCenters = this.panes.map((p) => {
        const rect = p.getBoundingClientRect()
        return rect.left + rect.width / 2
      })

      const closestIndex = paneCenters.reduce((closest, val, i, arr) => {
        return Math.abs(val - centerX) < Math.abs(arr[closest] - centerX)
          ? i
          : closest
      }, 0)

      this.setActive(closestIndex)
    }

    wrapper.addEventListener('pointerdown', pointerDown)
    wrapper.addEventListener('pointermove', pointerMove)
    window.addEventListener('pointerup', pointerUp)

    this.panes.forEach((pane, i) => {
      pane.addEventListener('click', () => this.setActive(i))
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const prevBtn = document.getElementById('tc-accordion-controls-prev')
  const nextBtn = document.getElementById('tc-accordion-controls-next')
  const accordion = new AccordionDrag('tc-accordion', prevBtn, nextBtn)

  prevBtn.addEventListener('click', () => {
    const newIndex = Math.max(0, accordion.activeIndex - 1)
    accordion.setActive(newIndex)
    update_btns()
  })

  nextBtn.addEventListener('click', () => {
    const newIndex = Math.min(
      accordion.panes.length - 1,
      accordion.activeIndex + 1
    )
    accordion.setActive(newIndex)
    update_btns()
  })

  new Swiper ('.testimonial-carosel-mobile', {
    spaceBetween: 0,
    slidesPerView: 'auto',
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
})
